<template>
  <b-card no-body class="list-filters">
    <!-- <div class="card-header">
      <b-form-checkbox v-model="filtersOpened" size="sm" button>
        <font-awesome-icon icon="filter" />
        <span v-if="activeFilters > 0" v-translate="{activeFilters: activeFilters}" :translate-n="activeFilters" translate-plural="%{ activeFilters } active">%{activeFilters} active</span>
      </b-form-checkbox>
    </div> -->
    <b-tabs fill card v-model="tabIndex" v-if="filtersOpened">
      <b-tab :title="$gettext('Quick Filters')" v-if="Boolean(quickFilters)">
        <b-card-text>
          <quick-filters :type="type" :quick-filters-definition="quickFilters" @filtering="applyFilters" @reset="emitReset" @save-filter="saveCurrentFilters" :no-querystring="noQuerystring" />
        </b-card-text>
      </b-tab>
      <b-tab :title="$gettext('Advanced Filters')" v-if="advanced && model.filters && model.filters.length > 0">
        <b-card-text>
          <advanced-filters :type="type" :model="model" @filtering="applyFilters" @reset="emitReset" @save-filter="saveCurrentFilters" :no-querystring="noQuerystring" />
        </b-card-text>
      </b-tab>
      <b-tab :title="$gettext('Saved Filters')" :disabled="(savedFilters && savedFilters[this.type] && savedFilters[this.type].length === 0) || !savedFilters[this.type]" v-if="!noQuerystring">
        <b-list-group>
          <b-list-group-item v-for="(savedFilter, index) in savedFilters[this.type]" :key="index" :href="savedFilter.url" class="d-flex justify-content-between align-items-center">
            {{ savedFilter.name }}
            <b-badge href="#" @click.stop.prevent="deleteSavedFilter(index)" variant="danger">✕</b-badge>
          </b-list-group-item>
        </b-list-group>
      </b-tab>
    </b-tabs>
  </b-card>
</template>

<script>
import AdvancedFilters from './AdvancedFilters'
import QuickFilters from './QuickFilters'

export default {
  name: 'ListFilters',
  components: {
    AdvancedFilters,
    QuickFilters
  },
  props: {
    type: {
      type: String,
      default: '',
      required: true
    },
    model: {
      type: Object,
      required: true
    },
    quickFilters: {
      type: Object,
      default: () => {}
    },
    advanced: {
      type: Boolean,
      default: true
    },
    noQuerystring: {
      type: Boolean,
      default: false
    },
    filtersOpened: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tabIndex: 0,
      savedFilters: {}
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.$nextTick(() => {
        this.tabIndex = this.quickFilters && this.advanced && this.$route.query.af ? 1 : 0
        this.updateSavedFilters()
      })
    },
    emitReset() {
      this.$emit('reset')
    },
    applyFilters(filters) {
      console.log('Filters', filters)
      // this.activeFilters = filters?.filtersToEmit.length
      this.$emit('apply-filters', filters)
      this.$root.$emit('activeFilters', filters?.filtersToEmit.length)
      this.$root.$emit('bv::refresh::table', this.type)
    },
    updateSavedFilters() {
      if (localStorage.savedFilters) {
        this.savedFilters = JSON.parse(localStorage.savedFilters)
      }
    },
    saveCurrentFilters(type) {
      console.log(type)
      let name = prompt(this.$gettext('Please set a name for this Filters Set'))
      if (name) {
        if (!this.savedFilters[this.type]) {
          this.savedFilters[this.type] = []
        }
        this.savedFilters[this.type].push({name: 'QUICK: ' + name, url: window.location.href})
        console.log(JSON.stringify(this.savedFilters))
      } else {
        alert(this.$gettext('You must write a name for this Filters Set'))
      }
      try {
        localStorage.savedFilters = JSON.stringify(this.savedFilters)
      } catch (e) {
        alert(this.$gettext('The Filters couldn\'t be saved'))
      }
      this.savedFilters = JSON.parse(localStorage.savedFilters)
      this.updateSavedFilters()
    },
    deleteSavedFilter(index) {
      this.savedFilters[this.type].splice(index, 1)
      localStorage.savedFilters = JSON.stringify(this.savedFilters)
      this.savedFilters = JSON.parse(localStorage.savedFilters)
    }
  }
}
</script>

<style lang="scss">
.list-filters {
  margin-bottom: 1rem !important;
  .card-header {
    border-bottom: 0 !important;
  }
  .tabs {
    .card-header {
      padding-top: 0 !important;
      border-bottom: 1px solid rgba(0, 0, 0, 0.125) !important;
    }
  }
}
</style>